// Mock data for Ravi Sahu and Associates CA Firm Website

export const firmInfo = {
  name: "Ravi Sahu and Associates",
  tagline: "Your Trusted Financial Partners",
  phone: "+91 8602666456",
  email: "ravi21sahu@gmail.com",
  address: "GF-02, Plot No 220 Zone 1 MP Nagar, Bhopal",
  logoUrl: "https://customer-assets.emergentagent.com/job_tax-audit-services/artifacts/8q519g3h_Untitled-design-4-1.png",
  facebook: "https://facebook.com/ravisahuassociates",
  instagram: "https://instagram.com/startup_mitra07",
  linkedin: "https://www.linkedin.com/in/ca-ravi-sahu-9b339479/",
  officeHours: {
    weekdays: "Monday - Saturday: 11:00 AM - 9:00 PM",
    weekend: "Sunday: Closed"
  },
  googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.648599407712!2d77.43079311495941!3d23.23395078486819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c43067864e253%3A0x8bce026817732cd2!2sRavi%20Sahu%20and%20Associates!5e0!3m2!1sen!2sin!4v1234567890"
};

export const services = [
  {
    id: 1,
    title: "Company Registration",
    slug: "company-registration",
    description: "Complete company incorporation services including Private Limited, LLP, OPC, Partnership and Proprietorship registration with expert guidance.",
    icon: "Building",
    featured: true,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
    detailPage: true
  },
  {
    id: 2,
    title: "GST Returns and Assessments",
    slug: "gst-services",
    description: "Comprehensive GST compliance services including registration, return filing, assessment handling, and advisory for businesses of all sizes.",
    icon: "FileText",
    featured: true,
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=600&h=400&fit=crop",
    detailPage: true
  },
  {
    id: 3,
    title: "Income Tax Returns and Assessments",
    slug: "income-tax-services",
    description: "Expert income tax return filing, assessment proceedings, tax planning, and consultation for individuals and corporates.",
    icon: "Calculator",
    featured: true,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
    detailPage: true
  },
  {
    id: 4,
    title: "Startup Consultancy",
    slug: "startup-consultancy",
    description: "End-to-end startup support including business planning, funding assistance, compliance setup, and growth strategies for new ventures.",
    icon: "Rocket",
    featured: true,
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop",
    detailPage: true
  },
  {
    id: 5,
    title: "Accounting & Bookkeeping",
    slug: "accounting-bookkeeping",
    description: "Professional accounting and bookkeeping services including financial record management, MIS reporting, and accounts outsourcing.",
    icon: "BookOpen",
    featured: false,
    detailPage: true
  },
  {
    id: 6,
    title: "Virtual CFO Services",
    slug: "virtual-cfo",
    description: "Strategic financial leadership and CFO services for businesses including financial planning, budgeting, and decision support.",
    icon: "UserCheck",
    featured: false,
    detailPage: true
  },
  {
    id: 7,
    title: "RERA Registration and Returns",
    slug: "rera-services",
    description: "Complete RERA compliance solutions for real estate projects including registration, quarterly returns, and regulatory compliance.",
    icon: "Building2",
    featured: false,
    detailPage: true
  },
  {
    id: 8,
    title: "Project Finance and CMA Data",
    slug: "project-finance",
    description: "Comprehensive project finance solutions, CMA data preparation, and financial feasibility reports for securing business loans.",
    icon: "TrendingUp",
    featured: false,
    detailPage: true
  },
  {
    id: 9,
    title: "Audit Services",
    slug: "audit-services",
    description: "Statutory audits, internal audits, tax audits, and comprehensive audit services ensuring complete financial compliance.",
    icon: "ClipboardCheck",
    featured: false,
    detailPage: true
  },
  {
    id: 10,
    title: "Scrutiny Assessments",
    slug: "scrutiny-assessments",
    description: "Expert handling of income tax and GST scrutiny cases with complete documentation and representation.",
    icon: "Search",
    featured: false,
    detailPage: false
  },
  {
    id: 11,
    title: "Business Advisory",
    slug: "business-advisory",
    description: "Strategic financial planning, business setup consulting, and comprehensive advisory services for growing businesses.",
    icon: "Briefcase",
    featured: false,
    detailPage: false
  },
  {
    id: 12,
    title: "NRI Taxation Services",
    slug: "nri-taxation",
    description: "Specialized tax services for Non-Resident Indians including tax filing, FEMA compliance, and investment advisory.",
    icon: "Globe",
    featured: false,
    detailPage: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Vijay Ramani",
    designation: "Managing Partner, Ishaan Builders and Developers",
    content: "Excellent service for RERA compliance and project finance. Their expertise helped us secure project funding smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Prashant Dixit",
    designation: "Aditya Medical Systems India Private Limited",
    content: "Very professional handling of our GST returns and assessments. Always available for consultation and clarifications.",
    rating: 5
  },
  {
    id: 3,
    name: "Ayush Khurana",
    designation: "Managing Director, Humbleheads India Private Limited",
    content: "Their income tax planning saved us significant amount. Highly recommend for both personal and corporate taxation.",
    rating: 5
  },
  {
    id: 4,
    name: "Vijay Gaur",
    designation: "CEO, Trans Tech and Fab",
    content: "Trusted partner for all our financial compliance needs. Prompt service and clear communication.",
    rating: 5
  },
  {
    id: 5,
    name: "Anurag Hariramani",
    designation: "Pehelwan Nutrition Private Limited",
    content: "Outstanding support for startup registration and compliance. They guided us through company formation, funding documentation, and regulatory requirements. Truly understand the startup ecosystem.",
    rating: 5
  },
  {
    id: 6,
    name: "Arpit Sahu",
    designation: "Director, Proxima Elite India Private Limited",
    content: "Exceptional GST expertise! They streamlined our GST compliance, helped us claim maximum input credits, and successfully handled complex assessment cases. Highly knowledgeable team.",
    rating: 5
  }
];

export const aboutContent = {
  title: "About Ravi Sahu & Associates",
  description: "Ravi Sahu & Associates is a trusted Chartered Accountant firm based in Bhopal, helping businesses and individuals save tax, stay compliant, and make better financial decisions. We simplify complex taxation and regulatory requirements so you can focus on growing your business with confidence.",
  expertise: [
    "RERA and Regulatory Compliance",
    "GST Compliance & Advisory",
    "Income Tax Planning & Filing",
    "Audit & Assurance Services",
    "Project Finance & CMA Data Preparation"
  ],
  whyChooseUs: [
    "Qualified Chartered Accountant from ICAI",
    "8+ years of experience",
    "Serving 1000+ satisfied clients across Madhya Pradesh",
    "Practical, business-focused approach (not just compliance)",
    "Prompt support and reliable guidance"
  ],
  credentials: [
    "Qualified Chartered Accountant from ICAI",
    "8+ years of experience",
    "Serving 1000+ satisfied clients across Madhya Pradesh",
    "Practical, business-focused approach (not just compliance)",
    "Prompt support and reliable guidance"
  ],
  image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=600&fit=crop"
};

export const heroContent = {
  title: "Expert Financial Solutions for Your Business",
  subtitle: "Professional Chartered Accountancy Services in Bhopal",
  description: "Comprehensive taxation, audit, and compliance services backed by expertise and commitment to excellence.",
  image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=1200&h=800&fit=crop"
};

// Industries data
export const industries = [
  { id: 1, name: "Real Estate & Construction", icon: "Building2" },
  { id: 2, name: "Information Technology", icon: "Laptop" },
  { id: 3, name: "Manufacturing & Trading", icon: "Factory" },
  { id: 4, name: "E-Commerce & Retail", icon: "ShoppingCart" },
  { id: 5, name: "Healthcare & Pharmaceuticals", icon: "Heart" },
  { id: 6, name: "Education Sector", icon: "GraduationCap" },
  { id: 7, name: "Hospitality & Tourism", icon: "Hotel" },
  { id: 8, name: "Financial Services", icon: "DollarSign" },
  { id: 9, name: "Logistics & Transportation", icon: "Truck" },
  { id: 10, name: "Agriculture & Food Processing", icon: "Sprout" },
  { id: 11, name: "Textiles & Garments", icon: "Shirt" },
  { id: 12, name: "Import & Export", icon: "Ship" }
];

// Blog/Articles data
export const blogArticles = [
  {
    id: 1,
    title: "GST Compliance Guide for Small Businesses in 2025",
    slug: "gst-compliance-guide-small-businesses",
    excerpt: "Complete guide to GST compliance for small businesses including registration, return filing, and common pitfalls to avoid.",
    category: "GST & Taxation",
    author: "CA Ravi Sahu",
    date: "December 15, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&h=500&fit=crop",
    content: `
# GST Compliance Guide for Small Businesses in 2025

Goods and Services Tax (GST) has revolutionized indirect taxation in India. For small businesses, understanding and maintaining GST compliance is crucial to avoid penalties and ensure smooth operations.

## When is GST Registration Mandatory?

GST registration becomes mandatory when:
- Annual turnover exceeds ₹40 lakhs (₹20 lakhs for special category states)
- Engaged in inter-state supply of goods or services
- Operating as an e-commerce seller
- Making taxable supplies on behalf of another registered person

## Types of GST Returns

Small businesses typically need to file:

### 1. GSTR-1 (Monthly/Quarterly)
- Details of outward supplies
- Invoice-wise details of sales
- Due date: 11th of next month (monthly) or 13th of month after quarter

### 2. GSTR-3B (Monthly)
- Summary return with tax payment
- Self-declared figures
- Due date: 20th of next month

### 3. GSTR-9 (Annual)
- Annual consolidated return
- Reconciliation of monthly/quarterly returns
- Due date: 31st December of next financial year

## Common Mistakes to Avoid

1. **Late Filing**: Always file returns on time to avoid late fees (₹50 per day per Act)
2. **Incorrect GSTIN**: Verify supplier GSTIN before claiming input tax credit
3. **Missing ITC Claims**: Regularly reconcile GSTR-2B to claim eligible credits
4. **Wrong HSN Codes**: Use correct HSN codes for your products/services

## Best Practices

- Maintain digital records of all invoices
- Reconcile accounts monthly
- Review GSTR-2B before filing GSTR-3B
- Set reminders for due dates
- Consult a CA for complex transactions

## Conclusion

GST compliance doesn't have to be complicated. With proper planning and timely action, small businesses can ensure smooth compliance and focus on growth.

**Need Help with GST Compliance?** Contact Ravi Sahu and Associates for expert guidance and hassle-free GST services.
    `
  },
  {
    id: 2,
    title: "Choosing the Right Business Structure: Pvt Ltd vs LLP vs OPC",
    slug: "choosing-right-business-structure",
    excerpt: "Detailed comparison of Private Limited Company, LLP, and One Person Company to help you choose the best structure for your business.",
    category: "Company Registration",
    author: "CA Ravi Sahu",
    date: "December 10, 2025",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=500&fit=crop",
    content: `
# Choosing the Right Business Structure: Pvt Ltd vs LLP vs OPC

Selecting the right business structure is one of the most critical decisions for entrepreneurs. Each structure has its own advantages, compliance requirements, and suitability based on business goals.

## Private Limited Company

### Advantages:
- **Limited Liability**: Personal assets protected
- **Easy Funding**: Can raise funds through equity
- **Credibility**: Higher trust among stakeholders
- **Perpetual Succession**: Continues despite member changes

### Requirements:
- Minimum 2 directors and 2 shareholders
- Regular ROC filings and audit requirements
- Board meetings mandatory

### Best For:
- Startups seeking venture capital
- Businesses planning to scale
- Multiple founders

## Limited Liability Partnership (LLP)

### Advantages:
- **Lower Compliance**: Less stringent than Pvt Ltd
- **Flexibility**: Partnership agreement governs operations
- **Tax Benefits**: No dividend distribution tax
- **Limited Liability**: Partners protected

### Requirements:
- Minimum 2 designated partners
- Annual ROC filing required
- Audit required if turnover exceeds ₹40 lakhs

### Best For:
- Professional service providers
- Small to medium businesses
- Partners wanting operational flexibility

## One Person Company (OPC)

### Advantages:
- **Single Ownership**: Complete control
- **Limited Liability**: Personal asset protection
- **Lower Compliance**: Simpler than Pvt Ltd
- **Easy Conversion**: Can convert to Pvt Ltd later

### Requirements:
- One director and one nominee
- Annual ROC filings required
- Turnover limit: ₹2 crores

### Best For:
- Solo entrepreneurs
- Small businesses with single owner
- Testing business ideas

## Comparison Table

| Feature | Pvt Ltd | LLP | OPC |
|---------|---------|-----|-----|
| Minimum Members | 2 | 2 | 1 |
| Compliance | High | Medium | Medium |
| Funding Options | Excellent | Limited | Limited |
| Management | Board | Partners | Director |
| Audit | Mandatory | Conditional | Conditional |

## Our Recommendation

- **Choose Pvt Ltd** if you plan to raise funding or scale significantly
- **Choose LLP** for professional services with partners
- **Choose OPC** for solo ventures with limited liability need

**Need Help Deciding?** Contact us for personalized consultation based on your business goals.
    `
  },
  {
    id: 3,
    title: "Income Tax Deductions Every Salaried Employee Should Know",
    slug: "income-tax-deductions-salaried-employees",
    excerpt: "Maximize your tax savings with these essential deductions available to salaried employees under the Income Tax Act.",
    category: "Income Tax",
    author: "CA Ravi Sahu",
    date: "December 5, 2025",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1554224154-22dec7ec8818?w=800&h=500&fit=crop",
    content: `
# Income Tax Deductions Every Salaried Employee Should Know

Tax planning is essential for maximizing take-home salary. Here are the key deductions available to salaried employees in India.

## Section 80C - Maximum Deduction: ₹1.5 Lakhs

Popular investments under 80C:
- **EPF/PPF**: Provident fund contributions
- **ELSS**: Equity Linked Savings Schemes
- **Life Insurance**: Premium payments
- **NSC**: National Savings Certificate
- **Tax Saver FDs**: 5-year tax saving deposits
- **Home Loan Principal**: Principal repayment
- **Tuition Fees**: Children's education

## Section 80D - Health Insurance

- Self and family: Up to ₹25,000
- Senior citizen parents: Additional ₹25,000
- Preventive health checkup: ₹5,000 (within above limits)

## Section 80CCD(1B) - NPS

- Additional ₹50,000 deduction
- Over and above 80C limit
- Invest in National Pension Scheme

## Section 24(b) - Home Loan Interest

- Self-occupied property: Up to ₹2 lakhs
- Let-out property: No upper limit

## Section 80E - Education Loan Interest

- Interest on education loan
- No upper limit
- Available for 8 years

## Section 80G - Donations

- Donations to approved charitable institutions
- 50% or 100% deduction depending on organization

## Standard Deduction

- ₹50,000 flat deduction
- Available to all salaried employees
- No proof required

## House Rent Allowance (HRA)

If living in rented accommodation:
- Actual HRA received
- 50% of salary (metros) or 40% (non-metros)
- Rent paid minus 10% of salary
- Minimum of above three

## Leave Travel Allowance (LTA)

- Exemption for domestic travel
- Twice in a block of 4 years
- Actual travel expenses or LTA received, whichever is lower

## New vs Old Tax Regime

**Old Regime**: All above deductions available
**New Regime**: Lower tax rates but most deductions not allowed

## Tax Planning Tips

1. Start planning at the beginning of financial year
2. Keep all investment proofs ready
3. Submit declarations to employer timely
4. Consider new vs old regime based on deductions
5. File ITR even if not mandatory

**Need Help with Tax Planning?** Consult our experts for personalized tax optimization strategies.
    `
  },
  {
    id: 4,
    title: "RERA Compliance Checklist for Real Estate Developers",
    slug: "rera-compliance-checklist-developers",
    excerpt: "Essential RERA compliance requirements for real estate developers including registration, returns, and ongoing obligations.",
    category: "RERA Compliance",
    author: "CA Ravi Sahu",
    date: "November 28, 2025",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=500&fit=crop",
    content: `
# RERA Compliance Checklist for Real Estate Developers

The Real Estate (Regulation and Development) Act, 2016 (RERA) has brought transparency and accountability to the real estate sector. Here's a comprehensive compliance checklist.

## 1. Project Registration

### When Required:
- Commercial projects > 500 sq.m.
- Residential projects > 8 units or 500 sq.m.
- Must register before advertising or selling

### Documents Needed:
- Title deeds and approved building plans
- Land details and ownership proof
- Financial details and project cost
- Commencement and completion certificates
- Authentication from architect and engineer

## 2. Maintain Separate Bank Account

- 70% of funds received must be deposited
- Can be withdrawn only for:
  - Land cost
  - Construction cost
  - Proportionate expenses

## 3. Quarterly Project Updates

File within 7 days of quarter end:
- Construction progress
- Number of bookings
- Sales details
- Details of amounts received and utilized

## 4. Annual Audit

- Chartered Accountant to certify:
  - Separate account maintenance
  - 70% fund utilization compliance
  - Project-wise fund allocation

## 5. Display Requirements

### On Website:
- Registration number prominently
- Sanctioned plans and layout
- Project specifications
- Timeline and completion status

### At Project Site:
- Board with RERA registration
- Updated project information
- Contact details

## 6. Carpet Area Declaration

- Declare actual carpet area
- Cannot include:
  - Walls
  - Service shafts
  - Common areas

## 7. Agreement Terms

- Use prescribed format
- Specify carpet area clearly
- Include possession timeline
- Mention delay penalties

## 8. Structural Defect Liability

- 5 years from possession
- Developer responsible for:
  - Structural defects
  - Quality issues
  - Workmanship problems

## 9. Advertisement Guidelines

- Include RERA registration number
- Use only approved plans
- No misleading information
- Actual photographs only

## 10. Timely Possession

- Complete within declared timeline
- Compensate for delays
- Cannot demand additional charges

## Common Violations to Avoid

1. Selling without registration
2. Demanding over 10% advance before agreement
3. Changing plans without authority approval
4. Not maintaining 70% separate account
5. Missing quarterly updates
6. Non-disclosure of encumbrances

## Penalties for Non-Compliance

- Project delay: Interest + 10% compensation
- False information: Imprisonment up to 3 years
- Non-registration: Imprisonment up to 3 years + fine
- Violation of orders: ₹10 lakhs or 5% project cost

## Benefits of RERA Compliance

- Enhanced credibility
- Access to institutional funding
- Better buyer confidence
- Reduced litigation
- Market advantage

**Need RERA Compliance Assistance?** Our experts can help you navigate RERA requirements seamlessly.
    `
  },
  {
    id: 5,
    title: "Virtual CFO Services: When Your Business Needs One",
    slug: "virtual-cfo-services-business-needs",
    excerpt: "Understanding when and why your growing business needs Virtual CFO services for strategic financial management.",
    category: "Business Advisory",
    author: "CA Ravi Sahu",
    date: "November 20, 2025",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop",
    content: `
# Virtual CFO Services: When Your Business Needs One

As businesses grow, financial complexity increases. While hiring a full-time CFO may not be viable for SMEs, Virtual CFO services offer the perfect solution.

## What is a Virtual CFO?

A Virtual CFO is an outsourced Chief Financial Officer who provides:
- Strategic financial planning
- Decision support
- Financial analysis and reporting
- Cash flow management
- Budgeting and forecasting

## When Do You Need a Virtual CFO?

### 1. Rapid Business Growth
- Scaling operations
- Multiple product lines
- Expanding to new markets
- Need for structured financial planning

### 2. Funding Requirements
- Seeking investor funding
- Planning for IPO
- Need for financial projections
- Investor presentation preparation

### 3. Complex Financial Operations
- Multiple entities or locations
- Complex revenue models
- International transactions
- Transfer pricing requirements

### 4. Strategic Decisions
- Merger and acquisition plans
- Business restructuring
- Cost optimization initiatives
- New venture evaluation

### 5. Compliance Burden
- Multiple regulatory requirements
- Audit and tax complexities
- Risk management needs
- Internal control implementation

## Services Provided by Virtual CFO

### Financial Planning & Analysis
- Annual budgets and forecasts
- Variance analysis
- KPI tracking and dashboards
- Scenario modeling

### Cash Flow Management
- Working capital optimization
- Cash flow forecasting
- Receivables and payables management
- Banking relationship management

### MIS Reporting
- Monthly financial statements
- Management reports
- Board presentations
- Performance dashboards

### Fundraising Support
- Financial model preparation
- Investor pitch deck
- Due diligence support
- Valuation assistance

### Cost Optimization
- Cost structure analysis
- Profitability improvement
- Vendor negotiations
- Process streamlining

### Compliance Management
- Tax planning and filing
- Audit coordination
- Regulatory compliance
- Risk assessment

## Benefits of Virtual CFO

### 1. Cost-Effective
- Save 60-70% compared to full-time CFO
- No employee benefits cost
- Pay only for services used

### 2. Expertise Access
- Experienced professionals
- Industry best practices
- Latest financial tools
- Diverse experience

### 3. Flexibility
- Scale services as needed
- No long-term commitment
- Adjust scope based on requirements

### 4. Objective Perspective
- Unbiased financial advice
- Independent assessment
- Fresh strategic insights

### 5. Focus on Core Business
- Founders focus on growth
- Operational management freed up
- Strategic rather than tactical

## Virtual CFO vs Traditional CFO

| Aspect | Virtual CFO | Traditional CFO |
|--------|-------------|-----------------|
| Cost | ₹25K-75K/month | ₹15L-50L/year |
| Availability | As needed | Full-time |
| Expertise | Multi-industry | Company-specific |
| Commitment | Flexible | Long-term |
| Implementation | Immediate | Takes time |

## How to Choose a Virtual CFO Service

1. **Relevant Experience**: Industry-specific knowledge
2. **Service Scope**: Comprehensive offerings
3. **Technology**: Modern tools and systems
4. **References**: Track record and testimonials
5. **Communication**: Responsive and accessible

## Typical Engagement Model

### Frequency:
- Weekly/bi-weekly meetings
- Monthly MIS and reports
- Quarterly strategic reviews
- On-demand consultation

### Deliverables:
- Financial statements
- Management reports
- Cash flow forecasts
- Strategic recommendations

## Success Stories

Many successful businesses have leveraged Virtual CFO services:
- Startups achieving funding targets
- SMEs improving profitability by 30%+
- Companies successfully navigating mergers
- Businesses scaling without financial chaos

## Getting Started

1. Assess your financial management needs
2. Define scope of services required
3. Evaluate service providers
4. Start with pilot engagement
5. Scale based on results

**Ready to Transform Your Financial Management?** Contact us to discuss how Virtual CFO services can accelerate your business growth.
    `
  }
];

